'use client';

import { createContext, useContext } from 'react';

import type { StateContextType } from './types';

export const Context = createContext<StateContextType | undefined>(undefined);

export const useConfiguration = () => {
  const stateContext = useContext(Context);

  if (stateContext === undefined) {
    throw new Error(
      'configurationContext must be used within a useConfiguration',
    );
  }
  return stateContext;
};
